import { observer } from 'mobx-react';
import React from 'react';

import { DbKey } from '../../../../adl-gen/common/db';
import { AppUser } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { TrainingOfferingData } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { Loader } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { TrainingOfferingStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { TrainingOfferingForm } from '../../components/forms/training-offering-form/training-offering-form';
import { TrainingOfferingDetailView } from '../../components/detail-views/training-offering-detail-view';
import { TrainingOfferingListEntry } from '../../components/lists/training-offering-lists/training-offering-list-view';

interface TrainingOfferingDetailScreenProps {
  pageLayout: AdminPageLayoutFn;
  navigateTo(route: Route): void;
  mode?: FormMode;

  store: TrainingOfferingStore;
  selectedEntry?: TrainingOfferingListEntry

  onCancel?(): Promise<void>;
  onUpdate?(appUserId: DbKey<AppUser>): Promise<void>;
}

@observer
export class TrainingOfferingDetailScreen extends React.Component<TrainingOfferingDetailScreenProps> {
  renderTrainingOfferingDetails = observer((data: TrainingOfferingData) => {
    const { onUpdate, selectedEntry, store } = this.props;

    if (selectedEntry && onUpdate) {
      return (
        <TrainingOfferingDetailView
          trainingOffering={selectedEntry}
          data={data}
          onUpdate={onUpdate}
          onLaunchTrainingOffering={store.getTrainingOfferingUrl}
          role={'super'}
        />
      );
    } else {
      return null;
    }
  });

  renderCreateTrainingOfferingForm = observer((data: TrainingOfferingData) => {
    const {
      navigateTo,
      onCancel,
      store
    } = this.props;

    if (onCancel) {
      return (
        <TrainingOfferingForm
          data={data}
          store={store}
          navigateTo={navigateTo}
          onCancel={onCancel}
        />
      );
    } else {
      return null;
    }
  });

  renderUpdateTrainingOfferingForm = observer((data: TrainingOfferingData) => {
    const { navigateTo, onCancel, selectedEntry, store } = this.props;

    if (selectedEntry && onCancel) {
      return (
        <TrainingOfferingForm
          item={selectedEntry}
          data={data}
          store={store}
          navigateTo={navigateTo}
          onCancel={onCancel}
        />
      );
    } else {
      return null;
    }
  });

  TrainingOfferingDetailsLoader = () => {
    const { selectedEntry, store, mode } = this.props;
    if (selectedEntry) {
      if (mode === 'update' || mode === 'delete') {
        return (
          <Loader
            state={store.loadingData}
            LoadedComponent={this.renderUpdateTrainingOfferingForm}
          />
        );
      } else {
        /// View
        return <Loader state={store.loadingData} LoadedComponent={this.renderTrainingOfferingDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={store.loadingData} LoadedComponent={this.renderCreateTrainingOfferingForm} />;
    }
  };

  render() {
    return (
      <this.props.pageLayout title={'Administration - Training Offerings'}>
        <this.TrainingOfferingDetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/training-offering-detail-screen/training-offering-detail-screen.tsx